import { usePDFPrintHook } from "@careinfo/layout";
import { tw } from "@careinfo/tailwind";
import loadable from "@loadable/component";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import APIS from "../../../constant/Endpoint";
import useGetHook from "../../../customHooks/useGetHook";
import usePostHook from "../../../customHooks/usePostHook";
import { postApiFormData } from "../../../helpers/AxiosInstance";
const CreateBankReceiptComponent = loadable(
  () =>
    import("../../../components/Transaction/Bank/BankReceipt/CreateBankReceipt")
);

const CreateBankReceipt = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { downloadPrint, isPrintLoading } = usePDFPrintHook();
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [openPrintPopup, setOpenPrintPopup] = useState(false);
  const navigate = useNavigate();
  const { refetch: billRefetch } = useGetHook({
    url: `${APIS.BILL}`,
    queryKey: ["bank-receipt"],

    params: {
      limit: 1,
      offset: 0,
      type: "Bank Receipt",
    },
  });
  const { refetch: numberSeriesRefetch } = useGetHook({
    queryKey: ["number-serires-bank-receipt"],
    url: APIS.NUMBER_SERIRES,
    params: {
      type: "Bank Receipt",
    },
  });

  const handleCreate = async (values: any, isDraft: any, setError: any) => {
    setIsLoading(true);
    const url = APIS.BILL;
    const formData = new FormData();
    formData.append("voucher_date", values?.voucher_date ?? null);
    formData.append("reference_number", values?.reference_number ?? "");
    values?.reference_date
      ? formData.append("reference_date", values?.reference_date)
      : null;
    formData.append("amount", values?.amount ?? 0);
    formData.append("account", values?.account);
    formData.append("party_account", values?.party_account);
    formData.append("number_series", values?.number_series);
    formData.append("entry_number", values?.entry_number);
    formData.append("balance_type", "debit");
    formData.append("type", "Bank Receipt");
    if (values?.attachment?.[0] && typeof values?.attachment !== "string") {
      formData.append("attachment", values?.attachment?.[0]);
    }
    isDraft
      ? formData.append("status", "Draft")
      : formData.append("status", "Success");
    formData.append("narration", values?.narration ?? "");
    try {
      const res = await postApiFormData({ url, formData, setError });
      if (res?.status === 201) {
        if (!isDraft) {
          setSelectedOrder(res?.data?.id);
          setOpenPrintPopup(true);
        } else {
          navigate("/accounting/bank-receipt");
        }
        toast.success("Create Successfully");
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["bank-account"],
    navigateURL: "",
  });
  const handleCreateBankAccount = async (
    values: any,
    setOpenAccountPopup: any,
    setError: any
  ) => {
    const url = APIS.COA;
    const formData = {
      ...values,

      is_group: false,
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res?.status === 201) {
        setOpenAccountPopup(false);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handlePrint = async () => {
    const url = APIS.BILL_PRINT;
    let formData = {
      ids: [selectedOrder],
      type: "Bank Receipt",
    };

    try {
      const res = await downloadPrint(url, formData);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div>
      <div className={tw`grid grid-cols-2 `}>
        <h1 className={tw`font-semibold text-xl leading-10`}>
          Create Bank Receipt
        </h1>
      </div>

      <CreateBankReceiptComponent
        handleCreate={handleCreate}
        isLoading={isLoading}
        handleCreateBankAccount={handleCreateBankAccount}
        isPostLoading={isPostLoading}
        billRefetch={billRefetch}
        numberSeriesRefetch={numberSeriesRefetch}
        openPrintPopup={openPrintPopup}
        setOpenPrintPopup={setOpenPrintPopup}
        handlePrint={handlePrint}
        isPrintLoading={isPrintLoading}
      />
    </div>
  );
};

export default CreateBankReceipt;
